var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import pubsub from "@viewlift/pubsub";
import Cookies from 'js-cookie';
import Auth from './Views/Auth';
import VerifyOtp from "./Views/VerifyOtp";
import './style.scss';
import StandAloneVerifyOtpModal from "./Views/VerifyOtp/verifyOtpModal";
import { useNavigate } from "react-router-dom";
import { fetchUserObject } from "../../MFEs/Monetization-Sdk/src/fetchStore";
import { logIn } from "./Helpers";
import { parseJSON } from "../../MFEs/Monetization-Sdk/src/helper";
import Spinner from "../../components/HomeLoadingScreen/Spinner";
import RecaptchaLegalText from "../../components/Recaptcha/RecaptchaLegalText";
import { subscriptionData } from "../../helpers";
import { getFontsStyles } from "../../modules/TrayModules/Helper/helper";
import { getStorageItem } from "../../helpers/storageManager";
var StandAloneAuthenticationV2 = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var _3 = __read(useState({ screen: false, type: '' }), 2), verifyOtp = _3[0], setVerifyOtp = _3[1];
    var navigate = useNavigate();
    var splashLoginEmail = parseJSON(sessionStorage.getItem("splashLoginEmail")) || "";
    var _4 = __read(useState((splashLoginEmail === null || splashLoginEmail === void 0 ? void 0 : splashLoginEmail.length) ? true : false), 2), isLoading = _4[0], setIsLoading = _4[1];
    var fontSetting = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.moduleData) === null || _a === void 0 ? void 0 : _a.moduleData) === null || _b === void 0 ? void 0 : _b.layout) === null || _c === void 0 ? void 0 : _c.fontSetting;
    var fontStyles = getFontsStyles(fontSetting);
    var handleOtpValue = function (data) {
        setVerifyOtp(data);
    };
    var isCheckoutScreen = props === null || props === void 0 ? void 0 : props.isCheckout;
    var changeView = function (data) {
        if (data < 4)
            setVerifyOtp(__assign(__assign({}, verifyOtp), { screen: false }));
    };
    var createAccountSubTitle = (_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.moduleData) === null || _d === void 0 ? void 0 : _d.moduleData) === null || _e === void 0 ? void 0 : _e.metadataMap) === null || _f === void 0 ? void 0 : _f.createAccountSubTitle;
    var metaData = (_h = (_g = props === null || props === void 0 ? void 0 : props.moduleData) === null || _g === void 0 ? void 0 : _g.moduleData) === null || _h === void 0 ? void 0 : _h.metadataMap;
    var escapeHtml = function (text) {
        var htmlEntities = {
            '"': "&quot;",
            "&": "&amp;",
            "'": "&#039;",
            "<": "&lt;",
            ">": "&gt;"
        };
        return text.replace(/["&'<>]/g, function (char) { return htmlEntities[char] || char; });
    };
    var sanitizedTosText = (metaData === null || metaData === void 0 ? void 0 : metaData.tosText) ? escapeHtml(metaData.tosText) : '';
    var sanitizedPrivacyPolicyText = (metaData === null || metaData === void 0 ? void 0 : metaData.privacyPolicyText) ? escapeHtml(metaData.privacyPolicyText) : '';
    var appendText = function () {
        createAccountSubTitle = metaData === null || metaData === void 0 ? void 0 : metaData.createAccountSubTitle.replace('$terms_of_service$', "<a aria-label=".concat(sanitizedTosText, " href=\"").concat(encodeURI(metaData === null || metaData === void 0 ? void 0 : metaData.tosPermalink), "\" class=\"consentLinks\" target=\"_blank\">").concat(sanitizedTosText, "</a>"));
        createAccountSubTitle = createAccountSubTitle === null || createAccountSubTitle === void 0 ? void 0 : createAccountSubTitle.replace('$privacy_policy$', "<a aria-label=".concat(sanitizedPrivacyPolicyText, " href=\"").concat(encodeURI(metaData === null || metaData === void 0 ? void 0 : metaData.privacyPolicyPermalink), "\" class=\"consentLinks\" target=\"_blank\">").concat(sanitizedPrivacyPolicyText, "</a>"));
        var authSubtitle = document.getElementById('authSubtitle');
        if (authSubtitle && createAccountSubTitle) {
            authSubtitle.innerText = '';
            authSubtitle.insertAdjacentHTML('beforeend', createAccountSubTitle);
        }
    };
    var handleNavigation = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (defaultPath) {
            var redirected;
            if (defaultPath === void 0) { defaultPath = "/"; }
            return __generator(this, function (_a) {
                redirected = getStorageItem("isRedirected") || { redirect: false, path: "", isDetailPage: false };
                (redirected === null || redirected === void 0 ? void 0 : redirected.redirect) ? navigate(redirected === null || redirected === void 0 ? void 0 : redirected.path) : navigate(defaultPath);
                return [2 /*return*/];
            });
        });
    };
    var checkRedirection = function (action) {
        if (action) {
            var currentPath = location.pathname;
            var response = fetchUserObject();
            if (currentPath == '/authentication' && response) {
                handleNavigation("/");
            }
        }
    };
    var handleRedirect = function (action) {
        subscriptionData();
        checkRedirection(action);
    };
    useEffect(function () {
        checkRedirection(true);
    }, []);
    useEffect(function () {
        pubsub.subscribe("verifyOtp", handleOtpValue); // subscription of verify Otp View
        pubsub.subscribe('progressState', changeView);
        pubsub.subscribe('redirection', handleRedirect);
        return function () {
            Cookies.set('RedirectToActivate', false);
        };
    }, []);
    useEffect(function () {
        appendText();
    }, [verifyOtp]);
    var handleSplashLogin = function (email) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            logIn({ email: email }).then(function (res) {
                var _a;
                var verifyOtpData = { type: { type: 'email', value: email, emailConsent: true, key: (_a = res === null || res === void 0 ? void 0 : res.identityAuthOtpInitiate) === null || _a === void 0 ? void 0 : _a.key }, screen: true, value: email };
                handleOtpValue(verifyOtpData);
                setIsLoading(false);
            });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (splashLoginEmail === null || splashLoginEmail === void 0 ? void 0 : splashLoginEmail.length) {
            handleSplashLogin(splashLoginEmail);
        }
    }, []);
    // isLoading is only required to handle splash otp screen.
    if (isLoading)
        return React.createElement(Spinner, null);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: isCheckoutScreen ? "authentication-header-v2 checkout-login-wrapper" : "authentication-header-v2" },
            React.createElement("div", { className: "Auth centered site-color" },
                verifyOtp.screen || !isCheckoutScreen && React.createElement("h2", { style: { textAlign: 'center', fontFamily: (_j = fontStyles === null || fontStyles === void 0 ? void 0 : fontStyles.loginV2Title) === null || _j === void 0 ? void 0 : _j.fontFamily, fontSize: (_k = fontStyles === null || fontStyles === void 0 ? void 0 : fontStyles.loginV2Title) === null || _k === void 0 ? void 0 : _k.fontSize } }, ((_o = (_m = (_l = props === null || props === void 0 ? void 0 : props.moduleData) === null || _l === void 0 ? void 0 : _l.moduleData) === null || _m === void 0 ? void 0 : _m.metadataMap) === null || _o === void 0 ? void 0 : _o.logInBtnText) || "LogIn"),
                (!verifyOtp.screen || isCheckoutScreen) && React.createElement(Auth, { showTvProviderBtn: props === null || props === void 0 ? void 0 : props.showTvProviderBtn, isCheckoutScreen: isCheckoutScreen, moduleData: ((_p = props === null || props === void 0 ? void 0 : props.moduleData) === null || _p === void 0 ? void 0 : _p.moduleData) || (props === null || props === void 0 ? void 0 : props.moduleData), state: verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.type, metadataMap: (_r = (_q = props === null || props === void 0 ? void 0 : props.moduleData) === null || _q === void 0 ? void 0 : _q.moduleData) === null || _r === void 0 ? void 0 : _r.metadataMap, continueWithoutSubscription: props === null || props === void 0 ? void 0 : props.continueWithoutSubscription, continueWithoutSubscriptionLabel: props === null || props === void 0 ? void 0 : props.continueWithoutSubscriptionLabel, checkoutModuleData: props === null || props === void 0 ? void 0 : props.checkoutModuleData, isFreeLogin: props === null || props === void 0 ? void 0 : props.isFreeLogin }),
                verifyOtp.screen && !isCheckoutScreen && React.createElement(VerifyOtp, { moduleData: (_s = props === null || props === void 0 ? void 0 : props.moduleData) === null || _s === void 0 ? void 0 : _s.moduleData, screenType: verifyOtp.type, data: verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.value, metadataMap: (_u = (_t = props === null || props === void 0 ? void 0 : props.moduleData) === null || _t === void 0 ? void 0 : _t.moduleData) === null || _u === void 0 ? void 0 : _u.metadataMap, consent: (_v = verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.type) === null || _v === void 0 ? void 0 : _v.emailConsent, keyProp: (_w = verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.type) === null || _w === void 0 ? void 0 : _w.key, isSplashLogin: (splashLoginEmail === null || splashLoginEmail === void 0 ? void 0 : splashLoginEmail.length) ? true : false, isCheckoutScreen: isCheckoutScreen, isFreeLogin: props === null || props === void 0 ? void 0 : props.isFreeLogin }),
                verifyOtp.screen && isCheckoutScreen && React.createElement(StandAloneVerifyOtpModal, { moduleData: ((_x = props === null || props === void 0 ? void 0 : props.moduleData) === null || _x === void 0 ? void 0 : _x.moduleData) || (props === null || props === void 0 ? void 0 : props.moduleData), screenType: verifyOtp.type, data: verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.value, metadataMap: ((_z = (_y = props === null || props === void 0 ? void 0 : props.moduleData) === null || _y === void 0 ? void 0 : _y.moduleData) === null || _z === void 0 ? void 0 : _z.metadataMap) || ((_0 = props === null || props === void 0 ? void 0 : props.moduleData) === null || _0 === void 0 ? void 0 : _0.metadataMap), consent: (_1 = verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.type) === null || _1 === void 0 ? void 0 : _1.emailConsent, keyProp: (_2 = verifyOtp === null || verifyOtp === void 0 ? void 0 : verifyOtp.type) === null || _2 === void 0 ? void 0 : _2.key, isCheckoutScreen: isCheckoutScreen, isFreeLogin: props === null || props === void 0 ? void 0 : props.isFreeLogin }))),
        !isCheckoutScreen ? React.createElement(RecaptchaLegalText, null) : React.createElement(React.Fragment, null)));
};
export default StandAloneAuthenticationV2;
